import Repository from "@/repositories/api.js"
const resource = "/super_admin/states"

export default {
  async getStates() {
    let response = await Repository.get(resource)
    return response.data.states
  }
}
